<div class="base-modal">
  <span class="base-modal__close-button" (click)="closeModal()">
    <i class="material-icons"> close </i>
  </span>
  <div class="base-modal__header">
    <h2 class="base-modal__title">Skype connection</h2>
  </div>

  <form [formGroup]="skypeForm">
    <div class="base-modal__body">
      <div class="brn-form-field">
        <input
          type="text"
          formControlName="client_id"
          placeholder="Chanel ID"
        />
      </div>
      <div class="brn-form-field">
        <input type="text" formControlName="secret" placeholder="Secret key" />
      </div>
      <div class="brn-form-field brn-form-field--clipboard">
        <input type="text" [value]="apiEndpoint" readonly />
        <span class="copy-to-clipboard" (click)="copyToClipboard()">
          <i class="material-icons"> content_copy </i>
        </span>
      </div>
    </div>

    <div class="base-modal__footer">
      <!-- --------------------------- New connection ---------------------------- -->
      <ng-container *ngIf="newConnection">
        <button
          class="button button--flat"
          (click)="createConnection()"
          [ngClass]="{ 'button--disabled': !validForm }"
        >
          Create connection
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
      </ng-container>
      <!-- --------------------------- Edit connection --------------------------- -->

      <ng-container *ngIf="!newConnection">
        <button
          class="button button--flat"
          (click)="updateConnection()"
          [ngClass]="{ 'button--disabled': !validForm }"
        >
          Save changes
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
        <button
          class="button button--flat button--danger"
          (click)="removeConnection()"
        >
          Remove connection
        </button>
      </ng-container>
    </div>
  </form>
</div>
